
define('template!pimPicturePositionerTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="positioner">\n  <div class="positioner__toolbar">\n  <div class="positioner__tabs js-tabs">\n    ';
 _.each(views, function (view) { ;
__p += '\n      <button type="button" class="positioner__tab js-tab" data-kind="view" data-view="' +
((__t = ( view )) == null ? '' : __t) +
'">\n        ' +
((__t = ( _.i18n('pimPositioner.picture', null, 'Picture') )) == null ? '' : __t) +
' ' +
((__t = ( view )) == null ? '' : __t) +
'\n      </button>\n    ';
 }); ;
__p += '\n    ';
 if (productPictures.length > 0) { ;
__p += '\n      <button type="button" class="positioner__tab js-tab" data-kind="product">\n        ' +
((__t = ( _.i18n('pimPositioner.productPictures', null, 'Product pictures') )) == null ? '' : __t) +
'\n      </button>\n    ';
 } ;
__p += '\n  </div>\n\n  <div class="positioner__tools">\n    <button type="button" class="positioner__tool js-undo" disabled title="' +
((__t = ( _.i18n('common.undo', null, 'Undo') )) == null ? '' : __t) +
' (Ctrl+Z)">&#8630;</button>\n    <button type="button" class="positioner__tool js-redo" disabled title="' +
((__t = ( _.i18n('common.redo', null, 'Redo') )) == null ? '' : __t) +
' (Ctrl+Y)">&#8631;</button>\n    <span class="positioner__tools-gap"></span>\n    <button type="button" class="positioner__tool js-zoom-out" title="' +
((__t = ( _.i18n('pimPositioner.zoomOut', null, 'Zoom out') )) == null ? '' : __t) +
'">&minus;</button>\n    <span class="positioner__zoom js-zoom-level">100%</span>\n    <button type="button" class="positioner__tool js-zoom-in" title="' +
((__t = ( _.i18n('pimPositioner.zoomIn', null, 'Zoom in') )) == null ? '' : __t) +
'">+</button>\n    <button type="button" class="positioner__tool positioner__tool--text js-zoom-fit" title="' +
((__t = ( _.i18n('pimPositioner.zoomFitHint', null, 'Fit the picture in the window (Ctrl+wheel to zoom)') )) == null ? '' : __t) +
'">' +
((__t = ( _.i18n('pimPositioner.zoomFit', null, 'Fit') )) == null ? '' : __t) +
'</button>\n  </div>\n  </div>\n\n  <div class="positioner__strip js-strip"></div>\n\n  <div class="positioner__body">\n    <div class="positioner__stage js-stage">\n      <div class="positioner__canvas js-canvas">\n        <img class="positioner__image js-image" src="" draggable="false" alt="">\n        <svg class="positioner__overlay js-overlay" xmlns="http://www.w3.org/2000/svg"></svg>\n      </div>\n      <div class="positioner__loading js-loading">' +
((__t = ( _.i18n('common.loading', null, 'Loading…') )) == null ? '' : __t) +
'</div>\n    </div>\n\n    <div class="positioner__side">\n      <div class="positioner__scope js-scope"></div>\n\n      <div class="positioner__areas js-areas">\n        ';
 _.each(areas, function (area) { ;
__p += '\n          <div class="positioner__area js-area" data-code="' +
__e( area.code ) +
'">\n            <span class="positioner__swatch" style="background: ' +
((__t = ( area.colour )) == null ? '' : __t) +
'"></span>\n            <span class="positioner__code">' +
__e( area.code ) +
'</span>\n            <span class="positioner__name">' +
__e( area.name ) +
'</span>\n            <span class="positioner__state js-state"></span>\n            <img class="positioner__ref js-ref" alt="" style="display: none;"\n                 title="' +
((__t = ( _.i18n('pimPositioner.refHint', null, 'The supplier\'s picture of this print position. Click to enlarge.') )) == null ? '' : __t) +
'">\n            ';
 if (area.ratio) { ;
__p += '\n              <i class="positioner__lock js-lock mdi-action-lock is-locked"\n                 title="' +
((__t = ( _.i18n('pimPositioner.lockHint', null, 'Keeps the print area\'s proportions ({w}×{h} mm). Click to resize freely.').replace('{w}', area.width).replace('{h}', area.height) )) == null ? '' : __t) +
'"></i>\n            ';
 } ;
__p += '\n          </div>\n        ';
 }); ;
__p += '\n      </div>\n\n      <div class="positioner__preview js-preview" style="display: none;">\n        <div class="positioner__preview-title js-preview-title"></div>\n        <img class="js-preview-img" alt="">\n      </div>\n\n      <div class="positioner__hint">\n        ' +
((__t = ( _.i18n('pimPositioner.hint', null, 'Click an area to place it. Drag it to move, the bottom-right grip to resize, the grip above it to turn, and any corner to pull it out of square.') )) == null ? '' : __t) +
'\n      </div>\n\n      <div class="error-message js-error"></div>\n\n      <div class="popup-footer">\n        <button type="button" class="btn js-cancel-popup">' +
((__t = ( _.i18n('common.cancel', null, 'Cancel') )) == null ? '' : __t) +
'</button>\n        <button type="button" class="btn btn-primary js-save">' +
((__t = ( _.i18n('common.save', null, 'Save') )) == null ? '' : __t) +
'</button>\n      </div>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

